import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const auth = {
  username: process.env.VUE_APP_USERNAME,
  password: process.env.VUE_APP_PASSWORD
};

export default new Vuex.Store({
  state: {
    site: [],
    projects: [],
    info: []
  },
  getters: {
    getProjectByUID: state => (uid, collection = state.projects) => {
      let i = collection.length;
      while (i--) {
        if (collection[i].uid === uid) {
          return collection[i];
        }
      }
    }
  },
  actions: {
    async loadSite({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "site",
            select: {
              title: true,
              url: true
            }
          },
          {
            auth
          }
        )
        .then(function(response) {
          commit("SET_SITE", response.data.result);
        });
    },
    async loadProjects({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('projects').children.listed",
            select: {
              title: true,
              uid: true,
              year: true,
              category: true,
              template: "page.intendedTemplate",
              description: "page.description_md.kirbytext",
              showinfo: "page.showInfo.toBool",
              files: {
                query: "page.files.sortBy('extension', 'asc', 'sort', 'asc')",
                select: {
                  filename: "file.filename",
                  caption: "file.caption",
                  type: "file.type",
                  url: "file.url",
                  srcset: "file.srcset([200, 400, 800, 1600])",
                  thumb: "file.resize(400).url"
                }
              }
            }
          },
          {
            auth
          }
        )
        .then(function(response) {
            // console.log(response);
            commit("SET_PROJECTS", response.data.result.data);
        });
    },
    async loadInfo({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('info')",
            select: {
              title: true,
              uid: true,
              text: "page.text_md.kirbytext",
              cv: "page.cv_md.kirbytext"
            }
          },
          {
            auth
          }
        )
        .then(function(response) {
          commit("SET_INFO", response.data.result);
        });
    }
  },
  mutations: {
    SET_SITE(state, site) {
      state.site = site;
    },
    SET_PROJECTS(state, projects) {
      let newProjects = [];
      for (var i = 0; i < projects.length; i++) {
        if (projects[i].template === "video") {
          let project = projects[i];
          let poster = projects[i].files[1];
          project.files = projects[i].files.slice(0, 1);
          project.files[0]["poster"] = poster;
          newProjects.push(project);
        } else {
          newProjects.push(projects[i]);
        }
      }
      state.projects = newProjects;
    },
    SET_INFO(state, pages) {
      state.info = pages;
    }
  }
});
